import { createRoute } from "@tanstack/solid-router";
import { inboxRoute } from "./inbox";

export const inboxTodoRoute = createRoute({
  getParentRoute: () => inboxRoute,
  path: "/todo/$todoId",
  component: InboxTodoDetailRoutePage,
});

function InboxTodoDetailRoutePage() {
  return null;
}
